// Business sectors and sub-sectors data

export const businessSectors = [
  'Agriculture & Food',
  'Energy & Utilities', 
  'Manufacturing & Industrial',
  'Construction & Real Estate',
  'Transport & Logistics',
  'Retail & Consumer Goods',
  'Hospitality & Tourism',
  'Healthcare & Pharmaceuticals',
  'Finance & Insurance',
  'Technology & Telecommunications',
  'Education & Training',
  'Media & Entertainment',
  'Government & Nonprofits'
];

export const countries = [
  'United States',
  'Canada',
  'United Kingdom',
  'Germany',
  'France',
  'Italy',
  'Spain',
  'Netherlands',
  'Belgium',
  'Switzerland',
  'Austria',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Australia',
  'New Zealand',
  'Japan',
  'South Korea',
  'Singapore',
  'Hong Kong',
  'India',
  'China',
  'Brazil',
  'Mexico',
  'Argentina',
  'Chile',
  'South Africa',
  'Nigeria',
  'Kenya',
  'Egypt',
  'United Arab Emirates',
  'Saudi Arabia',
  'Israel',
  'Turkey',
  'Russia',
  'Poland',
  'Czech Republic',
  'Hungary',
  'Ireland',
  'Portugal',
  'Greece',
  'Luxembourg',
  'Iceland',
  'Malta',
  'Cyprus'
];

export const businessSubSectors = {
  'Agriculture & Food': [
    'Crop Production (grains, fruits, vegetables, cash crops)',
    'Livestock & Poultry Farming',
    'Fisheries & Aquaculture',
    'Forestry & Timber',
    'Food & Beverage Processing',
    'Agricultural Equipment & Machinery',
    'Agrochemicals & Fertilizers',
    'Organic Farming & Specialty Foods',
    'Food Distribution & Wholesaling'
  ],
  'Energy & Utilities': [
    'Oil & Gas (Exploration, Refining, Distribution)',
    'Coal Mining',
    'Nuclear Energy',
    'Renewable Energy (Solar, Wind, Hydro, Geothermal)',
    'Electric Power Generation & Distribution',
    'Water Supply & Wastewater Management',
    'Waste Management & Recycling',
    'Natural Gas Distribution',
    'Energy Storage & Battery Technology'
  ],
  'Manufacturing & Industrial': [
    'Automotive & Auto Parts',
    'Aerospace & Defense Manufacturing',
    'Electronics & Semiconductors',
    'Chemicals & Petrochemicals',
    'Machinery & Equipment',
    'Steel, Metals & Mining Products',
    'Plastics & Packaging',
    'Textile & Apparel Manufacturing',
    'Industrial Automation & Robotics'
  ],
  'Construction & Real Estate': [
    'Residential Construction',
    'Commercial Construction (offices, malls, hotels)',
    'Infrastructure & Civil Engineering (roads, bridges, ports)',
    'Real Estate Development',
    'Real Estate Investment & Property Management (REITs)',
    'Architecture & Design Services',
    'Green & Sustainable Building',
    'Construction Materials (cement, glass, wood)'
  ],
  'Transport & Logistics': [
    'Road Transport & Trucking',
    'Rail Transport & Freight',
    'Airlines (Passenger & Cargo)',
    'Shipping & Ports',
    'Warehousing & Cold Chain Logistics',
    'Supply Chain Management',
    'Courier & Express Delivery',
    'Public Transit Systems',
    'Drones & Last-Mile Delivery Tech'
  ],
  'Retail & Consumer Goods': [
    'Food & Grocery Retail (supermarkets, convenience stores)',
    'Fashion & Apparel',
    'Luxury Goods & Jewelry',
    'Consumer Electronics',
    'Household Goods & Furniture',
    'E-Commerce & Online Marketplaces',
    'Beauty, Cosmetics & Personal Care',
    'Sports & Leisure Goods',
    'Department Stores & Specialty Retail'
  ],
  'Hospitality & Tourism': [
    'Hotels & Resorts',
    'Restaurants & Food Services',
    'Travel Agencies & Tour Operators',
    'Airlines & Cruise Lines (Tourism-related)',
    'Theme Parks & Attractions',
    'Event Management & Conferences',
    'Cultural & Heritage Tourism',
    'Eco & Adventure Tourism',
    'Online Travel Platforms (OTAs like Booking.com)'
  ],
  'Healthcare & Pharmaceuticals': [
    'Hospitals & Clinics',
    'Pharmaceuticals (Generics, Biopharma, Vaccines)',
    'Biotechnology',
    'Medical Devices & Equipment',
    'Diagnostics & Laboratories',
    'Health Insurance & Managed Care',
    'Telemedicine & Digital Health',
    'Elderly Care & Rehabilitation Services',
    'Wellness & Alternative Medicine'
  ],
  'Finance & Insurance': [
    'Banking (Retail, Corporate, Investment)',
    'Asset & Wealth Management',
    'Capital Markets (Exchanges, Brokerage, Securities)',
    'Insurance (Life, Health, Property & Casualty, Reinsurance)',
    'FinTech (Payments, Lending, Digital Banking)',
    'Venture Capital & Private Equity',
    'Microfinance & Cooperative Banking',
    'Credit Rating & Risk Assessment',
    'Accounting & Auditing Services'
  ],
  'Technology & Telecommunications': [
    'Information Technology Services (Consulting, Outsourcing, Cloud)',
    'Software Development (Enterprise, Consumer, SaaS)',
    'Telecommunications (Mobile, Fixed-line, Broadband, 5G)',
    'Hardware (Computers, Servers, IoT Devices)',
    'Artificial Intelligence & Machine Learning',
    'Cybersecurity',
    'Semiconductor & Chip Manufacturing',
    'Blockchain & Web3',
    'Data Centers & Cloud Infrastructure'
  ],
  'Education & Training': [
    'Primary & Secondary Education (K–12)',
    'Higher Education (Universities, Colleges)',
    'Vocational Training & Skill Development',
    'Online Learning / EdTech',
    'Corporate Training & Professional Development',
    'Test Prep & Tutoring Services',
    'Language Training',
    'Educational Content & Publishing',
    'Research Institutes & Think Tanks'
  ],
  'Media & Entertainment': [
    'Film Production & Distribution',
    'Television & Broadcasting',
    'Music & Audio Publishing',
    'Gaming & Esports',
    'Publishing (Books, Magazines, Digital Media)',
    'Advertising & Marketing Services',
    'Streaming Platforms (OTT, On-Demand Video)',
    'Sports Management & Sponsorship',
    'Virtual Reality & Immersive Entertainment'
  ],
  'Government & Nonprofits': [
    'Federal/National Government Services',
    'Local & Regional Government Services',
    'Defense & Public Safety (Police, Military, Fire Services)',
    'Public Healthcare & Social Services',
    'Public Education Institutions',
    'NGOs & International Organizations (UN, WHO, Red Cross)',
    'Religious & Faith-Based Organizations',
    'Charities & Foundations',
    'Policy & Regulatory Bodies'
  ]
};

export const issueCategories = [
  'Technical Support',
  'Billing & Payments',
  'Product Issues',
  'Account Management',
  'Service Quality',
  'Delivery & Logistics',
  'Installation & Setup',
  'Hardware Issues',
  'Software Issues',
  'Network Connectivity',
  'Data & Privacy',
  'Training & Onboarding',
  'Compliance & Legal',
  'General Inquiry'
];

export const issueTypes = {
  'Technical Support': [
    'Login Issues',
    'Password Reset',
    'System Error',
    'Performance Issues',
    'Browser Compatibility',
    'Mobile App Issues',
    'API Integration',
    'Database Connection',
    'Server Issues',
    'Security Concerns'
  ],
  'Billing & Payments': [
    'Payment Failed',
    'Billing Discrepancy',
    'Refund Request',
    'Subscription Issues',
    'Invoice Questions',
    'Payment Method Update',
    'Pricing Inquiry',
    'Tax Questions',
    'Credit Issues',
    'Billing Address Update'
  ],
  'Product Issues': [
    'Feature Not Working',
    'Product Defect',
    'Quality Issues',
    'Missing Features',
    'Product Compatibility',
    'Performance Problems',
    'Design Issues',
    'Functionality Questions',
    'Product Comparison',
    'Upgrade Issues'
  ],
  'Account Management': [
    'Account Setup',
    'Profile Update',
    'Access Permissions',
    'Account Deletion',
    'Data Export',
    'Account Migration',
    'Multiple Accounts',
    'Account Recovery',
    'Settings Configuration',
    'Account Verification'
  ],
  'Service Quality': [
    'Service Interruption',
    'Slow Response',
    'Poor Quality',
    'Service Unavailable',
    'Performance Issues',
    'Reliability Concerns',
    'Service Feedback',
    'Quality Complaints',
    'Service Comparison',
    'Improvement Suggestions'
  ],
  'Delivery & Logistics': [
    'Late Delivery',
    'Wrong Item',
    'Damaged Package',
    'Lost Package',
    'Delivery Address',
    'Shipping Costs',
    'Tracking Issues',
    'Delivery Schedule',
    'Return Process',
    'Exchange Request'
  ]
};

export const surveyTypes = [
  {
    id: 'paid',
    title: 'Paid Surveys',
    description: 'Earn rewards for your valuable feedback',
    icon: '💰',
    color: 'bg-green-100 text-green-800'
  },
  {
    id: 'unpaid',
    title: 'Community Surveys', 
    description: 'Help businesses improve their services',
    icon: '🤝',
    color: 'bg-blue-100 text-blue-800'
  }
];

export const gamificationElements = {
  badges: [
    { id: 'feedback_pro', name: 'Feedback Pro', description: 'Completed 10+ feedback submissions', icon: '🏆' },
    { id: 'survey_champion', name: 'Survey Champion', description: 'Participated in 20+ surveys', icon: '🎖️' },
    { id: 'early_adopter', name: 'Early Adopter', description: 'One of the first 100 users', icon: '🚀' },
    { id: 'quality_contributor', name: 'Quality Contributor', description: 'Received 95%+ helpful ratings', icon: '⭐' },
    { id: 'voice_expert', name: 'Voice Expert', description: 'Completed 50+ voice feedback sessions', icon: '🎙️' }
  ],
  levels: [
    { level: 1, name: 'Newcomer', minPoints: 0, color: 'text-gray-600' },
    { level: 2, name: 'Contributor', minPoints: 100, color: 'text-green-600' },
    { level: 3, name: 'Expert', minPoints: 500, color: 'text-blue-600' },
    { level: 4, name: 'Champion', minPoints: 1000, color: 'text-purple-600' },
    { level: 5, name: 'Legend', minPoints: 2500, color: 'text-gold-600' }
  ]
};